import { addCallerToPartner } from './addCallerToPartner';
import { addPartnerCallerCredits } from './addPartnerCallerCredits';
import { chargePartnerCallerCredits } from './chargePartnerCallerCredits';
import { fetchPartnerCaller } from './fetchPartnerCaller';
import { fetchPartnerCallers } from './fetchPartnerCallers';
import { removePartnerCallerCredits } from './removePartnerCallerCredits';
import { removePartnerCaller } from './removePartnerCaller';
import { updatePartnerCaller } from './updatePartnerCaller';
import { updatePartnerCallerRideAllowanceTier } from './updatePartnerCallerRideAllowanceTier';

export const partnerCallerService = {
  addCallerToPartner,
  addPartnerCallerCredits,
  chargePartnerCallerCredits,
  fetchPartnerCaller,
  fetchPartnerCallers,
  removePartnerCaller,
  removePartnerCallerCredits,
  updatePartnerCaller,
  updatePartnerCallerRideAllowanceTier,
};
